








import { Component, mixins, Watch } from 'nuxt-property-decorator';
import BaseLayoutMixin from "../../node_modules/sitis-nuxt/lib/cms/BaseLayoutMixin";
import SPage from "~/components/page/SPage.vue";
import { AppMixin } from "~/node_modules/sitis-nuxt/lib/mixins";
import * as path from "path";

@Component({
  components: { SPage }
})
export default class MainLayout extends mixins(BaseLayoutMixin, AppMixin) {
  show = false;
  isMainLayoutWrapper = false;


  mounted() {
    if(this.$route.fullPath.includes('kabinet-ohrany-zreniya') || this.$route.fullPath.includes('linses-stellest')) {
      this.isMainLayoutWrapper = true;
    }
  }
}


